import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import {
  UserSessionResponse,
  UserType,
  PermissionValue,
} from "../../utils/public-api";

@Injectable({
  providedIn: "root",
})
export class ApproveGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(): boolean {
    if (
      localStorage.getItem("intrasense-user:session") &&
      localStorage.getItem("intrasense-user:token")
    ) {
      let user: UserSessionResponse = JSON.parse(
        localStorage.getItem("intrasense-user:session") as string
      );
      if (user.can_approve == true) {
        return true;
      } else {
        this.router.navigate(["/error/401"]);
        return false;
      }
    } else if (
      sessionStorage.getItem("intrasense-user:session") &&
      sessionStorage.getItem("intrasense-user:token")
    ) {
      let user: UserSessionResponse = JSON.parse(
        sessionStorage.getItem("intrasense-user:session") as string
      );
      if (user.can_approve == true) {
        return true;
      } else {
        this.router.navigate(["/error/401"]);
        return false;
      }
    } else {
      this.router.navigate(["/"]);
      return false;
    }
  }
}

@Injectable({
  providedIn: "root",
})
export class NotApproveGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(): boolean {
    if (
      localStorage.getItem("intrasense-user:session") &&
      localStorage.getItem("intrasense-user:token")
    ) {
      let user: UserSessionResponse = JSON.parse(
        localStorage.getItem("intrasense-user:session") as string
      );
      if (user.can_approve == false) {
        return true;
      } else {
        return false;
      }
    } else if (
      sessionStorage.getItem("intrasense-user:session") &&
      sessionStorage.getItem("intrasense-user:token")
    ) {
      let user: UserSessionResponse = JSON.parse(
        sessionStorage.getItem("intrasense-user:session") as string
      );
      if (user.can_approve == false) {
        return true;
      } else {
        return false;
      }
    } else {
      this.router.navigate(["/"]);
      return false;
    }
  }
}
